"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaThemeProvider = exports.maxMedia = exports.minMedia = exports.DEFAULT_MEDIA_SIZES = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Default media sizes
var DEFAULT_MEDIA_SIZES = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 600,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560
}; // Media query generators

exports.DEFAULT_MEDIA_SIZES = DEFAULT_MEDIA_SIZES;

var createMedia = function createMedia(mediaName, valFn) {
  return new Proxy({}, {
    get: function get(proxy, key) {
      return function (props) {
        var size = props && props.theme && props.theme.media && props.theme.media[key];
        if (!size) throw new Error("No such media available: ".concat(key));
        var mediaSize = valFn(size);
        return "@media screen and (".concat(mediaName, ": ").concat(mediaSize, "px)");
      };
    }
  });
};

var minMedia = createMedia('min-width', function (s) {
  return s;
});
exports.minMedia = minMedia;
var maxMedia = createMedia('max-width', function (s) {
  return s - 1;
});
exports.maxMedia = maxMedia;
_styledComponents["default"].minMedia = minMedia;
_styledComponents["default"].maxMedia = maxMedia; // MediaThemeProvider

var media = DEFAULT_MEDIA_SIZES;

var createTheme = function createTheme(theme) {
  return Object.assign({
    media: media
  }, theme);
};

var MediaThemeProvider = function MediaThemeProvider(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  var newTheme = createTheme(theme);
  return _react["default"].createElement(_styledComponents.ThemeProvider, _extends({
    theme: newTheme
  }, props));
};

exports.MediaThemeProvider = MediaThemeProvider;